import React from 'react';

export default function PaginacionMobile({currentPage, total, pageSize, onPageChange }) {

    const totalPages = Math.ceil(total / pageSize);

    return (
        <div id="paginacion">
            <button key="next" className='showMore-button' onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages - 1}>
                Ver más
            </button>
        </div>
      );
}